module.exports = __webpack_public_path__ + "img/nentwichVerlag_logos_name_grey_grey.2e286be9.svg";